/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgentArtifactsControllerGetDownloadUrlQueryResponse, AgentArtifactsControllerGetDownloadUrlPathParams, AgentArtifactsControllerGetDownloadUrlQueryParams } from "../../models/agentArtifactsController/AgentArtifactsControllerGetDownloadUrl";

function getAgentArtifactsControllerGetDownloadUrlUrl(artifactId: AgentArtifactsControllerGetDownloadUrlPathParams["artifactId"]) {
  const res = { method: 'GET', url: `/api/v1/agent-artifacts/${artifactId}/download-url` as const }  
  return res
}

/**
 * @summary Get a presigned download URL for an agent-generated artifact
 * {@link /api/v1/agent-artifacts/:artifactId/download-url}
 */
export async function agentArtifactsControllerGetDownloadUrl(artifactId: AgentArtifactsControllerGetDownloadUrlPathParams["artifactId"], params: AgentArtifactsControllerGetDownloadUrlQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AgentArtifactsControllerGetDownloadUrlQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAgentArtifactsControllerGetDownloadUrlUrl(artifactId).url.toString(), params, ... requestConfig })  
  return res.data
}